
// import emailjs from '@emailjs/browser';
import { useEffect } from 'react';
// import toast from 'react-hot-toast';
import { AiOutlineMail } from 'react-icons/ai';
import { BsTelephone } from 'react-icons/bs';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { FaLocationArrow } from 'react-icons/fa';

const Contact = () => {

// const form =useRef()
//     const sendEmail = (e) => {
//         e.preventDefault();
//         const form1 =e.target
//         emailjs.sendForm('service_gg8w64e', 'template_mr9hwyh', form.current, '9MiE1hKbHiGAs4Uea')
//           .then((result) => {
//             toast.success(' Send Successfully')
//             form1.reset('')
//               console.log(result.text);
//           }, (error) => {
//               console.log(error.text);
//           });
//         }

        
  useEffect(() => {
    AOS.init({duration:1500});
}, [])
    return (
        <div  className='mb-24'>
            <h1 className='text-4xl text-center font-serif font-bold text-purple-500 '>Get In Touch</h1>
            
            <p className='text-gray-400 text-center mb-10 text-xl'>Feel free to drop me a line - Contact me</p>


            <div className="mx-auto lg:w-full ">
  <div className="hero-content  ">
    

    <div className="card flex-shrink-0 lg:w-1/2 sm:w-full shadow-2xl">
    {/* ref={form} onSubmit={sendEmail} */}
      <form  >
        <div className="form-control my-3">
          
          <input type="text" name='name' placeholder="Name" className="input input-secondary bg-transparent text-white" required/>
        </div>

        <div className="form-control my-3">
         
          <input type="text" name='email' placeholder="Email" className="input input-secondary bg-transparent text-white" required/>
        </div>
        
        <div className="form-control my-3 ">
          
          
          <textarea className="textarea textarea-secondary bg-transparent text-white" rows='7' name='message' placeholder="Message"></textarea>
        </div>

        <div className="form-control mt-6 w-36 justify-center lg:ml-44">
          <button className="btn bg py-10 ">Contact Me</button>
        </div>

      </form>
    </div>
  </div>
</div>



<div className="text-center  sm:w-full grid lg:grid-cols-3 sm:grid-cols-1 gap-5">
        
    <div className="card w-76 bg2 text-neutral-content mb-10 hover:border-solid border-2 hover:border-pink-500  hover:animate-pulse" data-aos="zoom-in-right">
  <div className="card-body items-center text-center">
    <h2 className="card-title text-2xl"><AiOutlineMail/></h2>
    <h2 className="card-title">Email</h2>
    <p>xyz123@gmail@gmail.com</p>
    <p>abc123@gmail.com</p>
    <p className='text-sm text-pink-500'>send a message</p>
   
  </div>
</div>
    <div className="card w-76 bg2 text-neutral-content mb-10 hover:border-solid border-2 hover:border-pink-500  hover:animate-pulse" data-aos="flip-left">
  <div className="card-body items-center text-center">
    <h2 className="card-title text-2xl"><BsTelephone/></h2>
    <h2 className="card-title">Phone</h2>
    <p>+8801636443876</p>
    <p>+8801638548993</p>
    <p className='text-sm text-pink-500'>send a message</p>
   
  </div>
</div>
    <div className="card w-76 bg2 text-neutral-content mb-10 hover:border-solid border-2 hover:border-pink-500  hover:animate-pulse" data-aos="zoom-in-left">
  <div className="card-body items-center text-center">
    <h2 className="card-title text-2xl"><FaLocationArrow/></h2>
    <h2 className="card-title">Location</h2>
    <p>Dhaka, Bangladesh</p>
    <p>Chitagong, Bangladesh</p>
    <p className='text-sm text-pink-500'>See map</p>
   
  </div>
</div>





    </div>
        </div>
    );
};

export default Contact;